/**
 * @file todoDismiss.ts
 * @brief Client twin of BACKEND boardroom/todoDismiss.mjs (05-10-2026).
 *
 * @details
 * A dismissed AI to-do stays in the meeting but leaves every list and count:
 * the Action items list (it moves to a closed "Dismissed" section), the
 * glance counts, the mindmap and search.
 */

type MaybeDismissed = { dismissedAt?: string | null } | null | undefined;

export function isDismissedTodo(todo: MaybeDismissed): boolean {
  return Boolean(todo?.dismissedAt);
}

export function activeTodos<T extends MaybeDismissed>(todos: readonly T[] | null | undefined): T[] {
  return (todos ?? []).filter((t) => !isDismissedTodo(t));
}
